import { useEffect, useState } from 'react'
import VerifyOTP from '../../components/login/VerifyOTP';
import { useDispatch } from 'react-redux';
import { login } from '../../redux-stores/slices/authSlice';
import { AppDispatch, getIntendedPath, RootState } from '../../redux-stores/store';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MobileView from '../../layouts/MobileView/MobileView';
import { fetchInfluencer } from '../../redux-stores/slices/influencerSlice';
import { INIT_IG_AUTH_ROUTE } from '../../constants/constants';
import { Link } from 'react-router-dom';
import { generateLoginOTP, verifyOTP } from '../../services/api/auth';
import AuthLayout from '../../layouts/AuthLayout';
import { getErrorMessage } from '../../utils/helpers';
import { toast } from 'react-toastify';
import AuthPhoneInput from '../../components/login/AuthPhoneInput';
import { useAuthPhoneCountries } from '../../hooks/useAuthPhoneCountries';
import { AuthPhoneValue, EMPTY_AUTH_PHONE } from '../../types/auth';
import { formatAuthPhoneDisplay, isValidAuthPhone } from '../../utils/phone';

const Login: React.FC = () => {

    const [otpSent, setOTPSent] = useState(false);
    const [phone, setPhone] = useState('');
    const [phoneValue, setPhoneValue] = useState<AuthPhoneValue>(EMPTY_AUTH_PHONE);
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { isAuthenticated } = useSelector((state: RootState) => state.auth);
    const connectionRequired = useSelector((state: RootState) => state.influencer.connectionRequired);
    const igAuthWall = useSelector((state: RootState) => state.auth.configurations?.ig_auth_wall === 'y')
    const isVerified = useSelector((state: RootState) => state.influencer.influencer?.verification?.is_verified);
    const { countries, defaultCountry } = useAuthPhoneCountries();

    const [mode, setMode] = useState<string|undefined>('');

    const [OTPSending, setOTPSending] = useState(false);

    const fetchUser = async (token: string) => {
        await dispatch(fetchInfluencer(token));
        await dispatch(login(token));
    }

    useEffect(() => {
        if (isAuthenticated) {
            const redirectURL = (connectionRequired && igAuthWall && !isVerified) ?  INIT_IG_AUTH_ROUTE : getIntendedPath();
            navigate(redirectURL);
        }
    }, [isAuthenticated, connectionRequired, navigate])

    const sendOTP = async () => {
    
            if (!isValidAuthPhone(phoneValue)) return;
    
            try {
                setOTPSending(true);
                const res = await generateLoginOTP({
                    mode: 'mobile',
                    username: phoneValue.username,
                    country: phoneValue.country,
                });
                if (res.status) {
                    setMode(res.mode);
                    setOTPSent(true)
                }
                return res;
            } catch (error) {
                console.error(error);
                toast.error(getErrorMessage(error))
            } finally {
                setOTPSending(false);
            }
    
        }

    return (
        <MobileView>
            <AuthLayout>
{
                    !otpSent ? (
                        <div className="position-relative h-100">
                            <h4 className="text-dark w-100 text-center auth-heading">Login To Your Account</h4>
                            <div className="auth-form">
                                <AuthPhoneInput
                                    value={phone}
                                    defaultCountry={defaultCountry}
                                    countries={countries}
                                    onChange={(nextPhone, fields) => {
                                        setPhone(nextPhone);
                                        setPhoneValue(fields);
                                    }}
                                    onEnter={sendOTP}
                                />
                                <button
                                    onClick={sendOTP}
                                    disabled={OTPSending || !isValidAuthPhone(phoneValue)} className="btn btn-primary">Continue</button>
                            </div>
                            <div className="auth-nav-content">
                                <span>Not a Member yet? <Link to="/register" className="text-primary fw-600">Sign up</Link></span>
                            </div>
                           
                        </div>
                    ) : (
                        <div className="position-relative h-100">
                            <VerifyOTP
                                mode={mode}
                                displayNumber={formatAuthPhoneDisplay(phoneValue)}
                                onResend={sendOTP}
                                onVerify={(otp) => verifyOTP({
                                    username: phoneValue.username,
                                    country: phoneValue.country,
                                    otp,
                                })}
                                onSuccess={(user) => fetchUser(user.token)}
                                onBackButtonClick={() => setOTPSent(false)}
                            />
                        </div>
                    )
                }
            </AuthLayout>
        </MobileView>

    )
}

export default Login
